import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { chain, get } from "lodash"
import { Row, Col, ListGroup, ListGroupItem, FormControl } from "react-bootstrap"

import { allCountries, mainCountriesNames, mainCountriesNamesSet } from "../../lib/countries"
import { getCities, getCitiesByCountry, getActivitiesByCity } from "../selectors"
import { sortByLocale } from "../../lib/Tools"
import { nameOrTitle, getText } from "../lib/text"

const CityFilter = ({
  sortedCountries,
  selectedCity,
  selectedCountry,
  onChange,
  citiesByCountry,
  activitiesByCity,
  inline,
  Cities,
}) => {
  const country = (selectedCity && Cities[selectedCity]) ? Cities[selectedCity].country : selectedCountry
  const countryCities = !country || country == "ALL" ? [] : citiesByCountry[country]

  // this could also be done in mapState or selectors
  // const topCities = sortByLocale(topBy(5, countryCities || [], city => (get(activitiesByCity, [city._id, "length"], 0))))
  
  //Why we were filtering this
  /*const sortedCities = [
    ...chain(countryCities)
      .filter(city => activitiesByCity[city._id] && activitiesByCity[city._id].length > 0)
      .value()
  ].sort((a, b) => nameOrTitle(a).localeCompare(nameOrTitle(b)))*/
  
  
  const sortedCities = countryCities.sort((a, b) => nameOrTitle(a).localeCompare(nameOrTitle(b)))

  const countryOptions = [
    {
      k: "ALL",
      a: country == "ALL",
      l: `Ver todo`,
    },
    ...(
      sortedCountries.map((c, i) => ({
        k: c,
        a: c == country,
        l: (i == 0
          ? `${allCountries[c].flag} ${getText(c)} (${(citiesByCountry[c] || []).length} ciudades)`
          : `${allCountries[c].flag} ${getText(c)} (${(citiesByCountry[c] || []).length})`
        ),
      }))
    )
  ]

  const onCountryClick = evt => {
    const country = evt.target.getAttribute("data-country")
    if (country == "ALL") {
      onChange("ALL", "ALL")
    }
    else {
      onChange(country, null)
    }
  }

  const onCityClick = evt => {
    const cityId = evt.target.getAttribute("data-id")
    if (cityId == "ALL") {
      onChange(country || "ALL", "ALL")
    }
    else {
      onChange(Cities[cityId].country, evt.target.getAttribute("data-id"))
    }
  }

  const cityOptions = [
    {
      k: "ALL",
      a: selectedCity == "ALL",
      l: "Todas",
    },
    ...sortedCities.map((city, i) => ({
      k: city._id,
      a: city._id == selectedCity,
      l: (i == 0
        ? `${city.name}${city.chinese ? ` / ${city.chinese}` : ""} (${get(activitiesByCity, [city._id, "length"], 0)} act.)`
        : `${city.name}${city.chinese ? ` / ${city.chinese}` : ""} (${get(activitiesByCity, [city._id, "length"], 0)})`
      ),
    }))
  ]

  if (inline) return (
    <Row style={{ display: "inline-block" }}>
      <Col md={6}>
        <FormControl
          componentClass="select"
          value={country}
          onChange={evt => (evt.target.value == "ALL" ? onChange(evt.target.value, "ALL") : onChange(evt.target.value, null))}
        >
          { countryOptions.map(({ k, l, a }) => (<option key={k} value={k} selected={a}>{l}</option>)) }
        </FormControl>
      </Col>
      <Col md={6}>
        <FormControl
          componentClass="select"
          value={selectedCity}
          onChange={evt => {
            const id = evt.target.value
            if (id == "ALL") onChange(country || "ALL", "ALL")
            else onChange(Cities[id].country, id)
          }}
        >
          { cityOptions.map(({ k, l, a }) => (<option key={k} value={k} selected={a}>{l}</option>)) }
        </FormControl>
      </Col>
    </Row>
  )
  else return (
    <Row className="inline-filter">
      <Col md={6}>
        <ListGroup>
          <ListGroupItem disabled>País (# ciudades)</ListGroupItem>
          {
            countryOptions.map(({ k, a, l }) => (
              <ListGroupItem key={k} active={a} data-country={k} onClick={onCountryClick}>{l}</ListGroupItem>
            ))
          }
        </ListGroup>
      </Col>
      <Col md={6}>
        <ListGroup>
          <ListGroupItem disabled>Ciudad (# actividades)</ListGroupItem>
          {
            cityOptions.map(({ k, a, l }) => (
              <ListGroupItem key={k} active={a} data-id={k} onClick={onCityClick}>{l}</ListGroupItem>
            ))
          }
        </ListGroup>
      </Col>
    </Row>
  )
}

CityFilter.propTypes = {
  // #TODO write propTypes
  // From papa
  selectedCountry: PropTypes.string,
  selectedCity: PropTypes.string,
  // From connect
  sortedCountries: PropTypes.arrayOf(PropTypes.string).isRequired,
  Cities: PropTypes.objectOf(PropTypes.object).isRequired,
  citiesByCountry: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.object)).isRequired,
  activitiesByCity: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.object)).isRequired
}

CityFilter.defaultProps = {
  selectedCountry: null,
  selectedCity: null
}

const mapStateToProps = (state, ownProps) => {
  const citiesByCountry = getCitiesByCountry(state, ownProps)
  const sortedCountries = [
    ...(sortByLocale(mainCountriesNames)),
    ...(chain(citiesByCountry)
      .keys()
      .filter(x => !mainCountriesNamesSet.has(x))
      // .sortBy(k => -1 * citiesByCountry[k].length)
      .value()
      .sort(k => k.localeCompare(k))
    )
  ]

  return {
    Cities: getCities(state, ownProps),
    citiesByCountry,
    activitiesByCity: getActivitiesByCity(state, ownProps),
    sortedCountries
  }
}

export default connect(mapStateToProps)(CityFilter)
